import React, { useState } from 'react';

const PageCompetencesIUT = () => {
    const [visibleSection, setVisibleSection] = useState(null);

    const toggleSection = (section) => {
        if (visibleSection === section) {
            setVisibleSection(null);
        } else {
            setVisibleSection(section);
        }
    };

    return (
        <div className="pageCompetIUT">
            <button onClick={() => toggleSection('developper')}>
                Développer des applications informatiques
            </button>
            {visibleSection === 'developper' && (
                <ul>
                    <li>Concevoir, coder, tester et intégrer une solution informatique pour un client.</li>
                    <li>Expliquer et communiquer l’avancée au client et aux utilisateurs.</li>
                    <li>Respecter les besoins exprimés dans un cahier des charges.</li>
                    <li>Appliquer les principes algorithmiques, veiller à la qualité du code et à sa documentation.</li>
                    <li>Prendre en compte les normes professionnelles, la législation et les enjeux sociétaux.</li>
                    <li>Développer sur différents supports (web, mobile, embarqué, IoT...).</li>
                </ul>
            )}

            <button onClick={() => toggleSection('optimiser')}>
                Optimiser des applications informatiques
            </button>
            {visibleSection === 'optimiser' && (
                <ul>
                    <li>Analyser et comparer différents algorithmes pour résoudre un problème.</li>
                    <li>Choisir des structures de données adaptées et évaluer leur impact.</li>
                    <li>Améliorer les performances d’une application (temps, mémoire, ressources...).</li>
                </ul>
            )}
            <button onClick={() => toggleSection('equipe')}>
                Travailler en équipe informatique
            </button>
            {visibleSection === 'equipe' && (
                <ul>
                    <li>Collaborer efficacement au sein d’une équipe pluridisciplinaire.</li>
                    <li>Communiquer et partager les informations de manière claire et adaptée.</li>
                    <li>S’intégrer dans une organisation (DSI, ESN...) et comprendre son rôle.</li>
                    <li>Développer des compétences interpersonnelles pour le travail collaboratif.</li>
                </ul>
            )}
        </div>
    );
};

export default PageCompetencesIUT;
